import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RightsHolderInfoViewModel } from "../../generated/data-contracts";
import { AuthorsUtils } from "../../utils";
import { AvisLoader, UnauthorizedLayout } from "../shared/components";
import { AvisPrimaryButton } from "../shared/components/buttons";
import { AvisDescriptiveText } from "../shared/components/form";
import { AvisContext } from "../shared/context/AvisContext";
import { ForbiddenPage } from "../shared/error/ForbiddenPage";

export function RightsHolder() {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const { ctxRightsHolders, updateRightsHolder, res } = useContext(AvisContext);

  const navigate = useNavigate();
  const handleButtonClick = (rightsHolder: RightsHolderInfoViewModel) => {
    setSubmitting(true);

    const preSelectedRightsHolder =
      AuthorsUtils.getRightsHolderFromUrl(ctxRightsHolders);

    updateRightsHolder(rightsHolder);

    if (
      preSelectedRightsHolder?.rightsHolderId !== rightsHolder?.rightsHolderId
    ) {
      navigate(AuthorsUtils.getStartPagePath(rightsHolder));
    }
  };

  const renderCard = (
    rightsHolder: RightsHolderInfoViewModel,
    index: number,
  ) => {
    return (
      <div className="rights-holder-card" key={index}>
        <div className="rights-holder-card-name">
          {AuthorsUtils.getRightsHolderFullName(rightsHolder)}
        </div>
        <AvisPrimaryButton
          label={res("button_Select")}
          onClick={() => handleButtonClick(rightsHolder)}
        />
      </div>
    );
  };

  const renderCards = () => {
    if (submitting) return <AvisLoader inline />;

    return (
      <div className="rights-holder-cards">
        {ctxRightsHolders?.map(renderCard)}
      </div>
    );
  };
  if (!ctxRightsHolders || ctxRightsHolders.length === 0)
    return <ForbiddenPage showLogoutButton />;

  return (
    <UnauthorizedLayout
      className="rights-holder"
      hideLogo
      info={<AvisDescriptiveText textKey="portal_RH_RightsHolderChoose_1" />}
    >
      <h2>{res("authors_RightsHolders_SelectRightsHolderTitle")}</h2>
      {renderCards()}
    </UnauthorizedLayout>
  );
}
